import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IContratoCliente } from '@model/ContratoCliente';
import { useContratoClienteStatusColor } from '@model/ContratoClienteStatus';
import { IContratoClienteFilter } from '@services/ClienteService';
import React from 'react';

export type ContratoTableProps = {
    data: IData<IContratoCliente, IContratoClienteFilter>
    isLoading: boolean
    menu: IMenu
}

export function ContratoTable ({ data, isLoading, menu }: ContratoTableProps) {
    const formatter = useFormatter();
    const contratoClienteStatusColor = useContratoClienteStatusColor();

    return (
        <React.Fragment>
            <TableLinearLoading isLoading={isLoading} />

            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Linha</TableHeaderCell>
                        <TableHeaderCell>Nº Contrato</TableHeaderCell>
                        <TableHeaderCell>Empresa</TableHeaderCell>
                        <TableHeaderCell>Valor</TableHeaderCell>
                        <TableHeaderCell>Status</TableHeaderCell>
                        <TableHeaderCellAction />
                    </TableRow>
                </TableHead>

                <TableBody>
                {
                    data.items.map((contratoCliente, index) => {
                        return (
                            <TableRow key={index}>
                                <TableKeyCell>{contratoCliente.contratoClienteId}</TableKeyCell>
                                <TableCell>{formatter.toCelular(contratoCliente.linhaNumero)}</TableCell>
                                <TableCell>{contratoCliente.linhaNumeroContrato}</TableCell>
                                <TableCell>{contratoCliente.linhaContratoOperadoraEmpresaNome}</TableCell>
                                <TableCell>{formatter.toFloat(contratoCliente.valorPlano)}</TableCell>
                                <TableCell className={contratoClienteStatusColor[contratoCliente.contratoClienteStatusId]}>{contratoCliente.contratoClienteStatusNome}</TableCell>
                                <TableCellAction onButtonClick={data.handleRowFocused(contratoCliente, menu.open)} />
                            </TableRow>
                        )
                    })
                }
                </TableBody>
            </TableNoResult>
        </React.Fragment>
    )
}